import GeoAppAPI from "../../search/apis/gemmiciApiService/GeoappAPI";

export default {
  updateDepartmentsWithBbox(departments) {
    return Promise.all(
      departments.map(department =>
        GeoAppAPI.retrieveDepartmentAPI(department).then(
          response => response.data
        )
      )
    );
  }
};
